<ion-app [class.dev]="isDev">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
